import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { NextRacesHomePageHeader } from './NextRacesHeader';
import { NextRacesSlider } from './racesSlider/NextRacesSlider';
import { useCommon } from 'src/domains/common/Common';
import { NextRacesState } from './NextRaces.state';
import { NextRacesWrapper, RacesSliderSection } from './racesSlider/NextRacesSlider.style';
import { Collapse } from 'src/ui/components/collapse/sports/01/Collapse';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { SectionHeader } from 'src/ui/components/collapse/sports/05/SectionHeader';

export const NextRacesHomePage = observer('NextRacesHomePage', () => {
    const common = useCommon();
    const {
        unifiedSportEventsTable,
        componentVariants: { sportsbookVariant },
    } = ConfigComponents.get(common).unifiedComponentConfig;
    const [nextRacesState] = React.useState(() => new NextRacesState(common));
    const { isNextRacesOpen, toggleNextRacesView } = nextRacesState;

    return (
        <NextRacesWrapper variant={sportsbookVariant}>
            {unifiedSportEventsTable ? (
                <SectionHeader
                    title={
                        <I18n
                            langKey='special-box.header.next-off'
                            defaultText='Next Off'
                        />
                    }
                />
            ) : (
                <Collapse
                    title={
                        <I18n
                            langKey='special-box.header.next-races'
                            defaultText='Next Races'
                        />
                    }
                    isOpen={isNextRacesOpen}
                    handleToggle={toggleNextRacesView}
                />
            )}
            {isNextRacesOpen ? (
                <RacesSliderSection variant={sportsbookVariant}>
                    <NextRacesHomePageHeader nextRacesState={nextRacesState} />
                    <NextRacesSlider nextRacesState={nextRacesState} />
                </RacesSliderSection>
            ) : null}
        </NextRacesWrapper>
    );
});
